import { render, staticRenderFns } from "./correction_topic.vue?vue&type=template&id=734a575b&scoped=true&"
import script from "./correction_topic.vue?vue&type=script&lang=js&"
export * from "./correction_topic.vue?vue&type=script&lang=js&"
import style0 from "./correction_topic.vue?vue&type=style&index=0&id=734a575b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734a575b",
  null
  
)

export default component.exports